import React, { Children } from 'react'
import UserRolesService from '../../lib/services/userRole/UserRolesService'
import RoleMethodEnum from '../../lib/services/userRole/APIMethodEnum'
import SessionService from '../../lib/services/SessionService'


interface Props {
    api: string;
    method: RoleMethodEnum;
    children: any;
  }


class ACLCheckPermission extends React.Component<Props, any> {
    constructor(props: Props) {
        super(props)

        this.state = {
            isEnabled: null
        }
    }

    componentDidMount() {

        // special case: if the user is p-admin bypass this check and enable all apis
        try {
            let partnerLogged = SessionService.getPartnerLogged()
            if( partnerLogged && partnerLogged.partnerId === 'p-admin' ) {
                this.setState({isEnabled: true})
                return
            }
        } catch (e) {
            //
        }

        new UserRolesService().isEnabled(this.props.api, this.props.method).then(isEnabled => {
            this.setState({isEnabled: isEnabled})        
        })
    }

    // conditional rendering based on state (loaded async from external api call)
    render() {
        if (this.state.isEnabled === true) {
            return (
                <span>{this.props.children}</span>
            )
        } else {
            return null
        }
    }
}

export default ACLCheckPermission
